/**
 * 补码
 */

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>补码</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" onSubmit="return false">

<!--      <el-form-item label="搜索：">-->
<!--        <el-input size="small" v-model="formInline.keyword" placeholder="关键字"></el-input>-->
<!--      </el-form-item>-->

<!--      <el-form-item>-->
<!--        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>-->

<!--      </el-form-item>-->

     <el-form-item label="SN：">

        <el-input  ref="inputdata"  size="small" v-model="formInline.SN" v-focus   @keyup.enter.native="inputchange()"  style="width:1200px;" ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="success" icon="el-icon-plus" @click="addneedbuma()">添加</el-button>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="del()">删除</el-button>
             <el-button size="small" type="warning" icon="el-icon-setting" @click="createpdf()">开始合成</el-button>
<!--      <el-button size="small" type="primary" icon="el-icon-caret-right" @click="handleEdit()">发货</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange"  :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="80px">
      </el-table-column>
<!--      <el-table-column  prop="filename" label="文件名">-->

<!--      </el-table-column>-->
      <el-table-column  prop="sn" label="SN">

      </el-table-column>
      <el-table-column  prop="package_NO" label="箱号">

      </el-table-column>
      <el-table-column  prop="filenames" label="所在合成pdf文件">
      </el-table-column>
      <el-table-column  prop="custom_ORDER_NO" label="客户订单号">
      </el-table-column>

      <el-table-column  prop="hope_DELIVER_DATE" label="期望收货日期" >
        <template slot-scope="scope">
          <div>{{scope.row.hope_DELIVER_DATE|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="order_DATE" label="下单日期" >
        <template slot-scope="scope">
          <div>{{scope.row.order_DATE|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="createtime" label="接收时间" >
        <template slot-scope="scope">
          <div>{{scope.row.createtime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="status" label="订单状态" :formatter = "stautsFormat">

      </el-table-column>


    </el-table>
    <el-table-footer size="small">

      <el-alert
        type="warning">
        {{errDatas}}
        <!--       {{value.TYPE}}-->
        <!--      {{value.COUNT}} 次-->

      </el-alert>

    </el-table-footer>



   <el-dialog :visible.sync="dialogVisible" @close="dislogClosed">

     <p>提示</p>
     <p>生成通知已发送到本地服务器,请到本地服务器查看PDF生成情况,切勿重复操作!!! </p>
     <span slot="footer" class="dialog-footer">
     <el-button @click="dialogVisible = false">关闭</el-button>
     </span>
   </el-dialog>

  </div>
</template>

<script>
  import {
    buma,
    getOrderBySn,
    getOrdersBySn,getneedbumalist,needbumadel
  } from '../../api/ordersMG'
import Pagination from '../../components/Pagination'
export default {
  name: "orders",
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      dialogVisible: false,
      formInline: {

      },
      options: [{
        value: '合并码L牌套餐',
        label: '合并码L牌套餐'
      },{
        value: '合并码吊牌套餐',
        label: '合并码吊牌套餐'
      }],
      selectdata: [],
      listData: [] , //用户数据
      errDatas:"" // 错误提醒

    }
  },

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.formInline.MATI_SET_NAME = this.options[0].value;
    this.getdata(this.formInline)
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      }
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },

    keyPress () {
      // nextTick 针对DOM 没有渲染出现Undefined问题
      this.$nextTick(() => {
        this.$refs.inputdata.focus()

      })

    },
    // 失去焦点
    inputblur () {

      // let that = this
      //
      // // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
      //
      // setTimeout(() => {
      //
      //   that.$refs.inputdata.focus()
      //
      // }, 10)

    },

    inputchange(){

      let val = this.formInline.SN+",";
      this.formInline.SN=val
      console.log("ddddddddddddd"+val);
  },
    addneedbuma()
    {
       let sns = this.formInline.SN;
      var params={
        "sns":sns
      }
      getOrdersBySn(params)
        .then(res => {

          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })

          } else {

            res.data.forEach((data)=>
            {
              this.listData.push(data)
            })

           // this.listData = res.data
             this.errDatas=res.msg
          }
          this.formInline.SN="";
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.$message.error('数据加载失败，请稍后再试！')
          this.formInline.SN="";
        })
    }
    ,
    del()
    {

      let params = {
        ids: ''
      }
      let len = this.selectdata
      if(len==0)
      {
        this.$message({
          type: 'warning',
          message: "请选择需要删除的数据"
        })
        return
      }
      let pdfNames = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          pdfNames.push(len[i].id)
        }
      }

      params.ids = pdfNames.join(',')
      this.loading = true
      needbumadel(params)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          } else {
            this.getdata(this.formInline)
            this.errDatas=[];
            this.$message({
              type: 'info',
              message: "删除成功"
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('未知错误！')
        })
    },
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getneedbumalist(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data

          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })

    },
    // snchange()
    // {
    //
    //   let val = this.formInline.SN;
    //
    //     getOrderBySn(this.formInline)
    //       .then(res => {
    //
    //         this.loading = false
    //         if (res.code != 0) {
    //           this.$message({
    //             type: 'info',
    //             message: res.msg
    //           })
    //
    //         } else {
    //           let isn=this.formInline.SN;
    //           if(res.data.length>0) {
    //
    //             var index = this.listData.findIndex(item => {
    //
    //               if ( item.sn == isn) {
    //                 return true;
    //               }
    //             })
    //             console.log(isn+"="+index)
    //             if(index==-1) {
    //
    //               this.listData.push(res.data[0])
    //
    //             }
    //             else
    //             {
    //
    //
    //               var index1 = this.errDatas.findIndex(item => {
    //
    //                 if ( item.sn == isn) {
    //                   return true;
    //                 }
    //               })
    //
    //               if(index1>-1)
    //               {
    //                 let count=this.errDatas[index1].COUNT;
    //                 this.errDatas[index1].COUNT=count+1;
    //
    //               }
    //               else
    //               {
    //                 let errinfo= {
    //                   sn: isn,
    //                   TYPE: "重复",
    //                   COUNT:1
    //                 }
    //                 this.errDatas.push(errinfo)
    //               }
    //
    //             }
    //           }
    //           else {
    //
    //             console.log("查不到数据");
    //             var index2 = this.errDatas.findIndex(item => {
    //               console.log("item.sn"+item.sn+",isn="+isn);
    //               if ( item.sn == isn) {
    //                 return true;
    //               }
    //             })
    //
    //             if(index2>-1)
    //             {
    //               let count=this.errDatas[index2].COUNT;
    //               this.errDatas[index2].COUNT=count+1;
    //
    //             }
    //             else
    //             {
    //               let errinfo= {
    //                 sn: isn,
    //                 TYPE: "查不到",
    //                 COUNT:1
    //               }
    //               this.errDatas.push(errinfo)
    //             }
    //           }
    //
    //         }
    //         this.formInline.SN="";
    //       })
    //       .catch(err => {
    //         this.loading = false
    //         console.log(err)
    //         this.$message.error('数据加载失败，请稍后再试！')
    //         this.formInline.SN="";
    //       })
    //
    // },
    createpdf()
    {

      let params = {
        ids: ''
      }
      let len = this.selectdata
      if(len==0)
      {
        this.$message({
          type: 'warning',
          message: "请选择需要待合成数据"
        })
        return
      }
      let pdfNames = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          pdfNames.push(len[i].id)
        }
      }

      params.ids = pdfNames.join(',')
      this.loading = true
      buma(params)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'warning',
              message: res.msg
            })
          } else {
            this.getdata(this.formInline)
            this.errDatas=[];
            this.dialogVisible=true;
            // this.$message({
            //   type: 'info',
            //   message: "生成通知已发送到本地服务器,请注意查看pdf生成情况。 pdf正在生成时，请不要再做其他生成操作，切记！！！"
            // })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('未知错误！')
        })
    },
    search() {
      this.getdata(this.formInline)
    },
    stautsFormat(row, column) {

      if (row.status === 0) {
        return '待合成'
      } else if (row.status === 1) {
        return '已合成'
      } else if (row.status === -1) {
        return '正在合成'
      }else if (row.status === 2) {
        return '已发货'
      }
    },
    dislogClosed()
    {
      this.getdata(this.formInline)
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;

}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/orders/Print.vue